const state = () => ({
    loading: false
})

const getters = {
    getLoading: (state) => state.loading,
}

const mutations = {
    setLoading(state, data) {
        state.loading = data
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
}
